import React from "react"

import SelectButton from '../../form_sections/SelectButton'

class LanguageFilter extends React.Component {
  nativeLanguageTags() {
    const { nativeLanguages } = this.props
    if (!nativeLanguages || nativeLanguages.length === 0) {
      return null
    }

    return nativeLanguages.map((entry) => (
      <span key={entry.language_id} className="matchFiltersModal__nativeTag">
        {entry.language.native}
      </span>
    ))
  }

  languageChoices() {
    return this.props.learningLanguages.map((language) => (
      <SelectButton
        key={language.language_id}
        morphism
        selected={this.props.filters.language_ids.includes(language.language_id)}
        onClick={() => this.props.updateLanguageIds(language.language_id)}
        buttonText={language.language.native}
      />
    ))
  }

  render() {
    return (
      <section className="matchFiltersModal__card">
        <h3 className="matchFiltersModal__sectionTitle">Languages</h3>

        {this.props.nativeLanguages && this.props.nativeLanguages.length > 0 && (
          <div className="matchFiltersModal__callout">
            <span className="matchFiltersModal__calloutLabel">Partners learning</span>
            <div className="matchFiltersModal__nativeTags">
              {this.nativeLanguageTags()}
            </div>
          </div>
        )}

        <p className="matchFiltersModal__sectionHint">Who speak natively:</p>
        <div className="matchFiltersModal__chipGroup">
          {this.languageChoices()}
        </div>
      </section>
    )
  }
}

export default LanguageFilter
